<template>
  <div>
    <p class="title text-left">及时雨小贷宋梅荣获“2015中国小微金融年度人物”称号</p>
    <p class="desc text-left">
      2016-4-9
      <span class="author">及时雨小额贷款</span>
    </p>
    <div class="main-content text-left">
      <div class="normal">
        <img src="../img/newsDetail/10-01.png" width="100%" alt="未显示" />
      </div>
      <p class="normal">2016年4月9日， 第六届中国小微金融机构联席会年会在北京召开。及时雨小贷宋梅荣获“2015中国小微金融年度人物”荣誉称号。</p>
      <p
        class="normal"
      >本次年度人物评选的主办单位为中国小微金融机构联席会、中国小微金融研究院、《中国普惠金融》，从全国范围内对2015年度中国小微金融行业的发展有突出贡献的人物进行筛选评定。</p>
      <div class="normal">
        <img src="../img/newsDetail/10-02.png" width="100%" alt />
      </div>
      <p class="center">
        中国普惠金融发展十年
        <br />历经了寒冬迎来春暖
        <br />及时雨小贷也迈向了第四个年头
        <br />三年来及时雨小贷潜心完善风控体系，
        <br />及时雨小贷的布局是什么？
        <br />企业发展终极目标是什么？
        <br />本文将深度解析。
      </p>

      <div class="border-text">
        <p class="text-bold">未来发展之重：数字化风控</p>
        <p class="color-text text-desc">依托技术手段解决风险管理</p>
        <p class="color-text">和规模化信贷效率问题</p>
      </div>

      <p class="normal">“很多年前，当我还在国有担保公司就职时，就已经开始筹备、搭建这套风险控制体系。”及时雨小贷宋梅如是说，“创业小贷公司时开始正式组织业务和技术人员开发这套系统，如今这套风控系统运作良好。”</p>
      <div class="normal">
        这套风险控制体系曾获得上海市金融创新三等奖，在提高效率、方便财务核算、利于风险控制等方面具有极高的经济价值和示范性。
        <span class="color-text">这套风险控制体系脱胎于及时雨小贷宋梅的小贷风控经验，耗时多年搭建完成，至今仍在根据实践和环境变化不断补充与优化。</span>
      </div>
      <p class="normal">为什么我们在风控体系上花费如此大的心力？</p>
      <p class="normal">信贷资产的质量评估是自上而下存在着各种风险因素，客户资产的调查、市场价值的评估、借款人资料的分析、政策分析等方面不仅需要专业的信贷员依托强大的风险意识，还需要专业的权威的分析判断，每个环节的风险都是交叉影响的。</p>
      <p class="normal">及时雨小贷的解决方案是依托技术手段，搭建切实有效的风控系统、提高风险定价准确性。在数字化风控领域，及时雨小贷宋梅的带领下起步早，凭借金融背景与扎实的实践经验，已经有所收。</p>

     <div class="border-text">
        <p class="text-bold">正在做的：打下风险控制这场硬仗</p>
        <p class="color-text text-desc">依托技术手段解决风险管理</p>
      </div>
      <p class="normal">及时雨小贷的核心团队均是金融科班出生，在小额贷款领域摸爬滚打十余年。宋梅本人有近20年小微金融从业经验，正因为理解金融、敬畏金融，平台组建了一支独立的深入到线下的风控团队，风控人员严格遵照内部风险控制体系的要求，一条一条一项一项的进行审核判断，对借款人和借款项目严格做好贷前、贷中、贷后调查。这是一套落地的、实用的、高效的风险管理方式，其主要方法论就是还原报表法与交叉验证法。</p>
      <p class="bold color-text"><span>A. 还原报表法</span></p>
      <p class="normal">数据管理在目前的中国理论大于实战，但是用数据管理做风控是我们的目标，及时雨小贷从一开始就朝这个方向去定位和努力。</p>
      <p class="normal">一方面通过接入合作机构的数据，比如征信机构数据和银行的征信数据，来获取外部采集数据和小微行业数据。然而这些对于做好风险控制来说还远远不够，所以我们运用“还原报表法”获取更多一手数据，主要用于还原没有报表的小微企业的经营情况。譬如我们给一个卖猪肉的商贩贷款，风控人员会直接清点借款人一天的收入，获取最直接真实的信息，然后根据“还原报表法”还原出一张损益表，损益表上有风控环节必须的数据，包括借款人的月可支配收入，其中娱乐成本等各种成本的计算，专业风控人员都会考虑到。得到这个月可支配收入之后，来推算能给这位借款人贷多少钱、贷多久、利率多少。</p>
      <p class="bold color-text">B. 交叉验证法</p>
      <p class="normal">一线人员根据“还原报表法”的要求采集数据，还原出借款人的经营损益报表。考虑到金融行业一线人员的道德风险，及时雨小贷的风控体系还补充使用“交叉验证法”，去验证一线人员提供的信息的真实准确性。财务报表都有一定的逻辑，多张表之间能够互相检验互相印证，这种方法对于确保数据的可靠性有很大的实际作用。然后，风控人员还会通过一系列看似神奇的定性项目去判断借款人的资质。</p>
      <p class="bold color-text">这套复杂的风险控制体系里有五大模块，每个模块里有十几个层次的数据，每个层次里又有近20项具体数据。</p>
     <div class="border-text">
        <p class="text-bold">着力布局</p>
        <p class="color-text text-desc">风控体系再升级，有效降低运营成本风控体系再升级，有效降低运营成本</p>
     </div>
     <p class="normal">及时雨小贷风控系统已经几乎完全实现无纸化办公，从输入数据到贷款、贷后管理、客服全都通过电脑系统操作，没有多余的人工介入，如此一来，有效降低了运营成本。</p>
     <p class="normal">风险评估定价，这是金融的核心。为了更加准确的为风险定价，及时雨小贷还在不断完善风控体系。准确的风险定价能够降低借款人的借款成本，使得及时雨小贷在借款端更有价格优势。</p>
     <p class="normal">借助自有的数据收集、外部数据整合来建立风险评级体系，利用互联网工具对人群行为习惯、喜好等做画像，通过多维度数据分析进行风险定价，<span class="color-text">做到信用可计算、风险可量化，最终解决规模化信贷效率问题，在运营成本上进一步良性压缩。</span></p>
     <p class="normal">许小年教授多次来公司考察并与基层员工直接对话，重点就在于理清这套风控体系。</p>
     <p class="normal">及时雨小贷已经迈进了第四个年头，三年来我们潜心做风控，<span class="color-text">也许过去看来是跑的慢了，但在行业向纵深发展的当下，在洗牌的战局中，我们的洞察与提前布局正在发挥力量与优势。</span></p>
     <p class="normal">及时雨小贷将在“2015中国小微金融年度人物”宋梅的带领下继续稳扎稳打、安全稳健发展，完善风控体系、发展普惠金融、成为小微企业发展中的及时雨。风云际会自奋蹄，大浪淘沙始得金。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsDetail8"
};
</script>

<style scoped lang="less">
@import "newsDetail.less";
</style>


// WEBPACK FOOTER //
// src/components/NewsDetail8.vue